module.exports = __webpack_public_path__ + "media/images/payment/maestro-b982e6c0b35da13a672cc1447c322350.svg";